import { render, staticRenderFns } from "./KanbanBoards.vue?vue&type=template&id=044fd8b8&"
import script from "./KanbanBoards.vue?vue&type=script&lang=js&"
export * from "./KanbanBoards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports